import styled from "@emotion/styled";
import { Flex, Text } from "styles/utility-components";

import { SuggestedQuestion } from "./types";

type SuggestedQuestionProps = SuggestedQuestion & {
  onClick: () => void;
};

export default function AiChatSuggestedQuestionContainer({
  title,
  subtitle,
  prompt,
  onClick,
}: SuggestedQuestionProps) {
  return (
    <Container onClick={onClick}>
      <Flex column gap={4}>
        {title && <Text bold>{title}</Text>}
        <Text>{subtitle || prompt}</Text>
      </Flex>
    </Container>
  );
}

const Container = styled.div(({ theme }) => ({
  padding: "12px 16px",
  border: `1px solid ${theme.colors.sysBorderDecorative}`,
  borderRadius: 8,
  cursor: "pointer",
  ":hover": {
    color: theme.colors.sysTextDefault,
    backgroundColor: theme.colors.sysPrimarySubtle,
    borderColor: theme.colors.sysPrimaryHover,
  },
}));
